import React from 'react';
import ReactTooltip from 'react-tooltip';

const styles = {
  available: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#ebf7eb',
    fontSize: 14,
    height: '100%',
    width: '100%',
    borderTop: '10px solid green',
    cursor:'pointer'
  }
}

const Available = ({index, slot, doctor, setSlotWithDoctor}) => (
  <td
    className="available-slot"
    rowSpan="1"
    key={index}
    onClick={()=>{setSlotWithDoctor(doctor, slot)}}
  >
    <ReactTooltip/>
    <div data-tip="Click to delete schedule" style={styles.available}> Available</div>
  </td>
);

export default Available;


// WEBPACK FOOTER //
// ./src/screens/schedules/slots/available.js